import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

import { Store } from '@ngxs/store';

import { UserResponse } from '@smarthead-api/models/user-response';

import { LanguageService } from '@shared/modules/language/services/language.service';

import { RouterLinkCreatorService } from '../../../../services/router-link-creator.service';
import { UserLogOut } from '../../../../state/app.actions';
import { UserUtils } from '../../../../utils/user-utils';
import { MainNavService } from '../../services/main-nav.service';

@Component({
  selector: 'sh-main-nav-mobile-footer-for-user',
  templateUrl: './main-nav-mobile-footer-for-user.component.html',
  styleUrl: './main-nav-mobile-footer-for-user.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class MainNavMobileFooterForUserComponent {
  @Output() closeMenu = new EventEmitter();

  loggedUser$ = this.nav.loggedUser$;
  languagesOpen$ = new BehaviorSubject(false);

  constructor(
    public nav: MainNavService,
    private routerLinkCreatorService: RouterLinkCreatorService,
    private store: Store,
    public languageService: LanguageService
  ) {}

  getUserTitle(loggedUser: UserResponse) {
    return UserUtils.generateUserName(loggedUser);
  }

  toAdmin(loggedUser: UserResponse) {
    this.closeMenu.emit();
    return this.routerLinkCreatorService.navigateToLoggedUser(loggedUser, 'ADMIN');
  }

  logout() {
    this.store.dispatch(new UserLogOut());
  }

  openLanguages() {
    this.languagesOpen$.next(true);
  }

  closeLanguages() {
    this.languagesOpen$.next(false);
  }

  onCloseMenu() {
    this.closeMenu.emit();
  }
}
